import axios from 'axios';
window.dataLayer = window.dataLayer || {};
window.gigyaHybris = window.gigyaHybris || {};
window.gigya = window.gigya || {};
// the prefix of the URL
axios.defaults.baseURL = window.ACC.config.encodedContextPath;
// default header for all POST request
axios.defaults.headers.post['CSRFToken'] = window.ACC.config.CSRFToken;
